import { Box } from '@mui/system'
import { useMediaQuery } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Mobile from './Mobile'
import Desktop from './Desktop'
import { selectUsersBatchActionsStatus } from '../../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusSlice'
import { getFilterUsersBatchActionsStatusList } from '../../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusThunk'

const Index = ({ openModal, setOpenModal }) => {
  const dispatch = useDispatch()
  const usersBatchActionsStatusStore = useSelector(selectUsersBatchActionsStatus)
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const [status, setStatus] = useState([])
  const [types, setTypes] = useState([])

  useEffect(() => {
    if (usersBatchActionsStatusStore?.activeFilters?.status?.length !== status.length) {
      setStatus(usersBatchActionsStatusStore?.activeFilters?.status || [])
    }
    if (usersBatchActionsStatusStore?.activeFilters?.types?.length !== types.length) {
      setTypes(usersBatchActionsStatusStore?.activeFilters?.types || [])
    }
  }, [usersBatchActionsStatusStore?.activeFilters])

  useEffect(() => {
    if ((openModal)) {
      dispatch(getFilterUsersBatchActionsStatusList({
        queries: {
          status,
          types,
        },
      }))
    }
  }, [status, types])

  return (
    <Box>
        {isXsScreen
          ? <Mobile
          openModal={openModal}
          setOpenModal={setOpenModal}
          status={status}
          setStatus={setStatus}
          types={types}
          setTypes={setTypes}
          />
          : <Desktop
          openModal={openModal}
          setOpenModal={setOpenModal}
          status={status}
          setStatus={setStatus}
          types={types}
          setTypes={setTypes}
          />}
    </Box>
  )
}

export default Index
